export default __webpack_public_path__ + "static/home-geo2-98f30d2b328cf75101a183f62253617d.gif";